module.exports = __webpack_public_path__ + "img/kknn7.cb3bb637.jpg";